/**
 * Lista de usuários com grupo ativo.
 * Os documentos ficam na página de cada pessoa.
 */

import { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { userDocumentService } from '../../../services/documentsApi'
import { accessGroupService } from '../../../services/erpApi'
import FilterLeftPicker from '../../../components/ERP/FilterLeftPicker'
import Avatar from '../../../components/Avatar/Avatar'
import './documentsShell.css'
import './UserDocumentsViewPage.css'

function UserDocumentsViewPage() {
  const navigate = useNavigate()
  const [users, setUsers] = useState([])
  const [accessGroups, setAccessGroups] = useState([])
  const [selectedAccessGroup, setSelectedAccessGroup] = useState('')
  const [loading, setLoading] = useState(true)

  const loadAccessGroups = useCallback(async () => {
    try {
      const response = await accessGroupService.getAll({ active: true })
      if (response.success) {
        setAccessGroups(response.data || [])
      }
    } catch (error) {
      console.error('Erro ao carregar grupos de acesso:', error)
    }
  }, [])

  const loadUsers = useCallback(async () => {
    setLoading(true)
    try {
      const filters = selectedAccessGroup ? { access_group_id: selectedAccessGroup } : {}
      const response = await userDocumentService.getAll(filters)

      if (response.success) {
        setUsers(response.data?.users || response.data || [])
      }
    } catch (error) {
      console.error('Erro ao carregar usuários:', error)
    } finally {
      setLoading(false)
    }
  }, [selectedAccessGroup])

  useEffect(() => {
    loadAccessGroups()
    loadUsers()
  }, [selectedAccessGroup, loadAccessGroups, loadUsers])

  if (loading) {
    return (
      <div className="docs-page">
        <div className="docs-state">Carregando usuários...</div>
      </div>
    )
  }

  return (
    <div className="docs-page user-documents-view-page">
      <header className="docs-header">
        <div>
          <h1 className="docs-title">
            Documentos <span className="docs-title-highlight">dos Usuários</span>
          </h1>
          <p className="docs-subtitle">Pessoas com grupo de acesso ativo</p>
        </div>
        <div className="docs-group-picker">
          <FilterLeftPicker
            label="Grupo de acesso"
            title="Grupos ativos"
            value={selectedAccessGroup}
            options={accessGroups.map((group) => ({
              value: String(group.id),
              label: group.name
            }))}
            onChange={setSelectedAccessGroup}
            emptyOptionLabel="Grupos ativos"
            searchable
            searchPlaceholder="Buscar grupo..."
          />
        </div>
      </header>

      {users.length === 0 ? (
        <section className="docs-panel">
          <p className="docs-empty">Nenhum usuário encontrado.</p>
        </section>
      ) : (
        <div className="docs-person-grid">
          {users.map((userData) => {
            const groupName = userData.access_group?.name || userData.access_group_name
            return (
              <button
                key={userData.user_id}
                type="button"
                className="docs-person-card"
                onClick={() => navigate(`/erp/documents/users/${userData.user_id}`)}
              >
                <Avatar
                  name={userData.user_name}
                  email={userData.user_email}
                  imageUrl={userData.avatar_url}
                  size="lg"
                />
                <div className="docs-person-info">
                  <strong>{userData.user_name || `Usuário #${userData.user_id}`}</strong>
                  {userData.user_email ? <span>{userData.user_email}</span> : null}
                  {userData.phone ? <span>{userData.phone}</span> : null}
                  {groupName ? <em>{groupName}</em> : null}
                </div>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default UserDocumentsViewPage
